import script from "./bdc.vue?vue&type=script&setup=true&lang=js"
export * from "./bdc.vue?vue&type=script&setup=true&lang=js"

import "./bdc.vue?vue&type=style&index=0&id=0e6f0f04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e6f0f04"]])

export default __exports__